import { setSearchTerm } from '../../../State/searchTerm'

export default (query) => (dispatch) => {

  dispatch(setSearchTerm(query.target.value))
    
}